import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { SistemaDisponibleDTO, GrupoDisponibleDTO, SectorDisponibleDTO } from './types'

const getEndpoint = (url = '') => `sector-comercial-config${url}`

export const HttpSectorSistemaGrupo = {
    getSistemas: (codSector: number, codPais?: number): Promise<SistemaDisponibleDTO[]> =>
        HttpAxiosRequest.getWithQueryParamsSerializer(
            getEndpoint(`/${codSector}/sistemas`),
            codPais ? { sinCodPais: codPais } : {}
        ),

    updateSistemas: (codSector: number, idsSistema: number[]): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint(`/${codSector}/sistemas`), idsSistema),

    getGruposPorSistema: (codSector: number, codSistema: number): Promise<GrupoDisponibleDTO[]> =>
        HttpAxiosRequest.get(getEndpoint(`/${codSector}/sistemas/${codSistema}/grupos`)),

    updateGrupos: (codSector: number, codSistema: number, idsGrupo: number[]): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint(`/${codSector}/grupos`), { codSistema, idsGrupo }),

    // Por Sistema
    getSectoresPorSistema: (codSistema: number, codPais?: number): Promise<SectorDisponibleDTO[]> =>
        HttpAxiosRequest.getWithQueryParamsSerializer(
            getEndpoint(`/por-sistema/${codSistema}/sectores`),
            codPais ? { sinCodPais: codPais } : {}
        ),

    getGruposPorSistemaYSector: (codSistema: number, codSector: number): Promise<GrupoDisponibleDTO[]> =>
        HttpAxiosRequest.get(getEndpoint(`/por-sistema/${codSistema}/sectores/${codSector}/grupos`)),

    updateSectoresPorSistema: (codSistema: number, codPais: number, idsSector: number[]): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint(`/por-sistema/${codSistema}/sectores`), { codPais, idsSector })
}
